// extracted by mini-css-extract-plugin
export default {"your_rd":"Tw","title":"Uw","subtitle":"Vw","rd_bio_wrapper":"Ww","rd_text_mobile":"Xw","rd_bio":"Yw","img":"Zw","rd_info":"ax","rd_name":"bx","rd_stat":"cx","rd_text":"ex","btn_mobile":"fx"};
    if(module.hot) {
      // 1713969931986
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  